// extracted by mini-css-extract-plugin
export default {"card":"ExerciseCard_card__p9Cx0","card_logo":"ExerciseCard_card_logo__M+T3F","main":"ExerciseCard_main__NGP3q"};